import { z } from 'zod';

export const pricingRowSchema = z.object({
  year: z.string().nullish(),
  make: z.string().nullish(),
  model: z.string().nullish(),
  modelBase: z.string().nullish(),
  cost: z
    .number({ invalid_type_error: 'Cost is required', required_error: 'Cost is required' })
    .min(0, 'Cost must be positive'),
});

export const optionFormSchema = z.object({
  code: z.string().trim().min(1, 'Code is required'),
  name: z.string().trim().min(1, 'Name is required'),
  description: z.string().nullish(),
  pricing: z.array(pricingRowSchema),
});

export type OptionFormValues = z.infer<typeof optionFormSchema>;
export type PricingRowValues = z.infer<typeof pricingRowSchema>;
